<section class="cmn-innerpage-wrapper new-chart-accounts">
  <h2 class="cmn-inner-heading">
    {{ activityId ? "Edit" : "Add" }} Petty Cash Activity
  </h2>
  <form [formGroup]="addPettyCashActivityForm">
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Employee <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Employee</mat-label>
          <mat-select formControlName="employeeId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No data found'"
                (input)="onSearchEmployee($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let employee of employeesData"
              [value]="employee.id"
            >
              {{ employee?.firstName + " " + employee?.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('employeeId')?.touched &&
              addPettyCashActivityForm.get('employeeId')?.hasError('required')
            "
          >
            Employee is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <div class="amt-wrapper">
          <label for="">Amount</label>
          <label *ngIf="currentBalance" for=""
            >Current available balance : {{ currentBalance }}</label
          >
          <label
            *ngIf="employeePettyCashStatus === false && currentBalance === null"
            for=""
            >Enter opening balance</label
          >
        </div>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter amount"
            formControlName="amount"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('amount')!.touched &&
              addPettyCashActivityForm.get('amount')!.hasError('required')
            "
          >
            Amount is required.
          </mat-error>
        </div>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('amount')!.touched &&
              addPettyCashActivityForm.get('amount')!.hasError('min')
            "
          >
            Amount cannot be 0.
          </mat-error>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Type <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select type</mat-label>
          <mat-select formControlName="type">
            <mat-option value="IN"> IN </mat-option>
            <mat-option value="OUT"> OUT </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('type')?.touched &&
              addPettyCashActivityForm.get('type')?.hasError('required')
            "
          >
            Type is required.
          </mat-error>
        </div>
      </div>

      <div *ngIf="employeePettyCashStatus === false" class="form-wrapper">
        <label for="">Petty Cash Number<span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Petty Cash Number"
            formControlName="pettyCashNumber"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('pettyCashNumber')!.touched &&
              addPettyCashActivityForm
                .get('pettyCashNumber')!
                .hasError('required')
            "
          >
            Petty Cash Number is required.
          </mat-error>
        </div>
      </div>

      <div *ngIf="employeePettyCashStatus === false" class="form-wrapper">
        <label for="">Currency <span class="red">*</span></label>
        <mat-form-field>
          <mat-select
            placeholder="Select Currency"
            formControlName="currencyId"
          >
            <mat-option
              *ngFor="let currency of currencyData"
              [value]="currency.id"
            >
              {{ currency?.currencyCode }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('currencyId')!.touched &&
              addPettyCashActivityForm.get('currencyId')!.hasError('required')
            "
          >
            Currency is required.
          </mat-error>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">description<span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Description"
            formControlName="description"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('description')!.touched &&
              addPettyCashActivityForm.get('description')!.hasError('required')
            "
          >
            Description is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Account <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Account</mat-label>
          <mat-select formControlName="accountId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No accounts found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of bankAccountsData" [value]="bank.id">
              {{ bank.accountName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              addPettyCashActivityForm.get('accountId')?.touched &&
              addPettyCashActivityForm.get('accountId')?.hasError('required')
            "
          >
            Account is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button [disabled]="loading" class="cmn-cancel-btn" (click)="onCancel()">
        Cancel
      </button>
      <button [disabled]="loading" class="cmn-next-btn" (click)="onSave()">
        Save
      </button>
    </div>
  </form>
</section>
